import { EBUY_TYPE, MANUAL_OPP_TYPES } from "constants/opportunities";
import { toSentenceCase } from "utils/string";

export const opportunitiesLabel = (n) =>
  n === 1 ? "1 opportunity" : `${n} opportunities`;

export const getHumanizedStatus = (opportunity) => {
  const { status, active, opportunitySource, opportunityType } = opportunity;

  if (opportunityType === MANUAL_OPP_TYPES.SIMPLE) {
    return null;
  }

  if (opportunitySource === EBUY_TYPE) {
    return status ? toSentenceCase(status) : null;
  }

  let statusValue = null;

  if (opportunityType === "OCDS") {
    statusValue = status;
  } else if (active === true) {
    statusValue = "Active";
  } else if (active === false) {
    statusValue = "Not Active";
  }
  return statusValue;
};
